import React from "react";
import { Button } from "@mui/material";

export interface ModalDialogConfirmButtonsProps {
  /** Determines which button uses the contained variant + autoFocus */
  defaultButton?: "OK" | "CANCEL";

  cancelButtonText?: string;
  cancelButtonDisabled?: boolean;
  cancelButtonVisible?: boolean;
  onCancelButtonClick?: () => void;

  okButtonText?: string;
  okButtonDisabled?: boolean;
  okButtonVisible?: boolean;
  okButtonWarningColor?: boolean;
  onOKButtonClick?: () => void;
}

export const ModalDialogConfirmButtons: React.FC<
  ModalDialogConfirmButtonsProps
> = ({
  defaultButton = "CANCEL",
  cancelButtonText = "Cancel",
  cancelButtonDisabled = false,
  cancelButtonVisible = true,
  onCancelButtonClick,
  okButtonText = "OK",
  okButtonDisabled = false,
  okButtonVisible = true,
  okButtonWarningColor = false,
  onOKButtonClick,
}) => {
  const isCancelPrimary = defaultButton === "CANCEL";
  const isOkPrimary = defaultButton === "OK";

  return (
    <>
      {/* Cancel Button */}
      {cancelButtonVisible && (
        <Button
          variant={isCancelPrimary ? "contained" : "outlined"}
          autoFocus={isCancelPrimary}
          focusRipple
          onClick={onCancelButtonClick}
          tabIndex={isCancelPrimary ? 1 : 2}
          disabled={cancelButtonDisabled}
        >
          {cancelButtonText}
        </Button>
      )}

      {/* OK Button */}
      {okButtonVisible && (
        <Button
          variant={isOkPrimary ? "contained" : "outlined"}
          autoFocus={isOkPrimary}
          focusRipple
          color={okButtonWarningColor ? "warning" : "primary"}
          onClick={onOKButtonClick}
          tabIndex={isOkPrimary ? 1 : 2}
          disabled={okButtonDisabled}
        >
          {okButtonText}
        </Button>
      )}
    </>
  );
};

export default ModalDialogConfirmButtons;
